import type { IItem } from '../../Items/IItem'
import { Tooltip } from '../../Components/Tooltip/Tooltip'
import { Trans, useTranslation } from 'react-i18next'
import { columnNameToTitleMapping } from '../GridMetaData'

const useMapPropertyToTranslation = () => {
  const { t } = useTranslation()

  const translate = (key: string) => {
    return t(columnNameToTitleMapping[key])
  }

  return translate
}

type Props = {
  data: IItem
  value: string
}

export const UploadOrderCellRenderer = ({ data, value }: Props) => {
  const { t } = useTranslation()
  const translatePropertyName = useMapPropertyToTranslation()
  const isValid = data.validationResult?.isValid

  // only object properties whose value is false
  const invalidProperties = Object.keys(data.validationResult?.properties || {})
    .filter((key) => !data.validationResult?.properties[key])
    .map(translatePropertyName)
    .join(', ')

  return (
    <>
      {value}{' '}
      {!isValid ? (
        <Tooltip
          style={{ maxWidth: '30rem' }}
          content={
            <Trans
              components={{ strong: <strong /> }}
              i18nKey="list_invalid_fields"
              values={{ invalidFields: invalidProperties }}
            />
          }
        >
          <span style={{ color: 'red' }}>⏺</span>
        </Tooltip>
      ) : null}
    </>
  )
}
